





































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ConfirmDialog extends Vue {
  @Prop()
  readonly title: string;
  @Prop()
  readonly body: string;
  @Prop({ default: "Yes" })
  readonly yesText: string;
  @Prop({ default: "No" })
  readonly noText: string;
  @Prop({ default: 450 })
  readonly width: number;
  @Prop()
  readonly textColor: string;

  dialog = false;
  resolve: any = null;

  show() {
    this.dialog = true;
    return new Promise(resolve => {
      this.resolve = resolve;
    });
  }
  confirm(bool: boolean) {
    this.dialog = false;
    this.resolve(bool);
    this.resolve = null;
  }
}
